'use strict';
const mmWidgets = require('./mm-widgets');
mmWidgets.fn.inputValidationWidget = function () {
	const validators = {
		number: function (n) {
			return (!isNaN(parseFloat(n)));
		},
		nonBlank: function (s) {
			return s && s.trim().length > 0;
		},
		positive: function (n) {
			return parseFloat(n) > 0;
		},
		accountName: function (s) {
			return s && s.trim().length > 0 && s.indexOf('@') === -1;
		}
	};
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.on('input', function (e) {
			const target = e.target,
				validator = target.getAttribute('data-mm-validate-input');
			if (validators[validator](target.value)) {
				target.classList.remove('validation-error');
			} else {
				target.classList.add('validation-error');
			}
		});
	});
};
